module.exports = __webpack_public_path__ + "static/img/step-2-image-3.62f76ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/faqNew/img/step-2-image-3.png
// module id = lv+N
// module chunks = 1